var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8026 28.8663C24.1961 29.145 24.7033 29.2147 25.1555 29.0436C25.6077 28.8712 25.9402 28.485 26.0404 28.0169C27.1025 23.0255 29.6789 10.3917 30.6456 5.8512C30.719 5.50899 30.5967 5.15333 30.3279 4.92478C30.059 4.69623 29.6862 4.63023 29.3538 4.75367C24.2291 6.65052 8.44691 12.5721 1.99617 14.959C1.58673 15.1105 1.32029 15.5041 1.33374 15.9355C1.3484 16.3682 1.63929 16.7434 2.0585 16.8693C4.95143 17.7346 8.74879 18.9385 8.74879 18.9385C8.74879 18.9385 10.5234 24.2978 11.4486 27.0233C11.5647 27.3655 11.8324 27.6344 12.1856 27.7273C12.5376 27.8189 12.914 27.7224 13.1768 27.4743C14.663 26.0712 16.9607 23.9018 16.9607 23.9018C16.9607 23.9018 21.3264 27.1027 23.8026 28.8663ZM10.3462 18.2614L12.3983 25.0299L12.8541 20.7436C12.8541 20.7436 20.7825 13.5926 25.3022 9.51657C25.4342 9.39679 25.4525 9.19635 25.3425 9.0558C25.2337 8.91525 25.0333 8.88225 24.883 8.97758C19.6447 12.3227 10.3462 18.2614 10.3462 18.2614Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.5f967fd3fcc97f16c65990337a9df3af.svg";
export { ForwardRef as ReactComponent };